export default {"src":"/_next/static/media/img_main_section3_3.531e4c8f.svg","height":188,"width":320,"blurWidth":0,"blurHeight":0};